import { render, staticRenderFns } from "./option-compensation-card.vue?vue&type=template&id=edb81cf4&scoped=true"
import script from "./option-compensation-card.vue?vue&type=script&lang=ts"
export * from "./option-compensation-card.vue?vue&type=script&lang=ts"
import style0 from "./option-compensation-card.vue?vue&type=style&index=0&id=edb81cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb81cf4",
  null
  
)

export default component.exports